// Translation keys map:
export const northwesternCustom = (intl) => ({
  bullet: [
    intl.formatMessage({
      id: 'aspire.communityCustomisationText.profilePictureBullet',
      defaultMessage: 'Appear friendly and warm in your profile picture',
    }),
    intl.formatMessage({
      id: 'aspire.communityCustomisationText.professionalAttireBullet',
      defaultMessage: 'Wear professional attire related to your work',
    }),
  ],
});
